<template>
  <div class="main">
    <div class="main_right">
      <div class="page_info">
        <Breadcrumb class="breadcrumb">
          <BreadcrumbItem>生产批次</BreadcrumbItem>
        </Breadcrumb>
        <div class="searchBox">
          <div>
            <Button type="primary" icon="plus-round" @click="addProduction" v-if="authList.indexOf('007002') !== -1">添加</Button>
          </div>
        </div>

        <Table border height="520" ref="bath_table" :columns="columns" :data="tableData"></Table>
        <page :total="total" show-sizer class="table_page" @on-change="changePageNo" @on-page-size-change="changePageSize" show-total></page>
      </div>
    </div>
    <Modal
      v-model="openSimple"
      title="添加生产批次"
      @on-ok="sureAdd"
      @on-cancel="cancelAdd">
      <p style="margin-bottom: 10px;">
        <span style="display:inline-block;margin-right: 10px;font-size: 14px;width: 65px;text-align: right;"><span style="color: red;">*</span>批次号</span>
        <InputNumber :max="999" :min="1" v-model="lotNo" style="width: 300px;"></InputNumber>
      </p>
      <p style="margin-bottom: 10px;">
        <span style="display:inline-block;margin-right: 10px;font-size: 14px;width: 65px;text-align: right;"><span style="color: red;">*</span>生产日期</span>
        <DatePicker type="date" :editable="false" v-model="produceDate" style="width: 300px"></DatePicker>
      </p>
      <p>
        <span style="display:inline-block;margin-right: 10px;font-size: 14px;width: 65px;text-align: right;vertical-align: top;">备注</span>
        <Input type="textarea" :rows="4" v-model="memo" style="width: 300px;resize: none;" :maxlength=32 />
      </p>
    </Modal>
  </div>
</template>

<script>
import {httpUrl} from '../../api'
import {errorHandler} from '../../util/errorHandler'
import {nError, nSuccess} from '../../util/notice'
import {getAuthStr} from '../../util/bus'

export default {
  name: 'production-bath',
  data () {
    return {
      authList: '',
      total: 0,
      columns: [
        {
          title: '批次号',
          key: 'lotNo',
          align: 'center'
        }, {
          title: '生产日期',
          key: 'produceDate',
          align: 'center'
        }, {
          title: '备注',
          key: 'memo',
          align: 'center'
        }, {
          title: '创建时间',
          key: 'createTime',
          align: 'center'
        }
      ],
      reqbody: {
        pageSize: 10,
        pageNo: 1
      },
      lotNo: 1,
      produceDate: '',
      memo: '',
      tableData: [],
      openSimple: false
    }
  },
  created () {
    this.authList = getAuthStr()
    this.getFactorySettingPage()
  },
  methods: {
    getFactorySettingPage () {
      this.$axios.post(`${httpUrl.url}/manage/lot/getPage`, this.reqbody)
        .then(res => {
          let data = res.data.data
          data.list.map(v => {
            if (v.createTime) {
              v.createTime = v.createTime.slice(0, 19)
            } else {
              v.createTime = '--'
            }
          })
          this.tableData = data.list
          this.total = data.total
        })
        .catch(errorHandler('获取数据失败'))
    },
    addProduction () {
      this.openSimple = true
    },
    sureAdd () {
      if (!this.lotNo) {
        nError('批次号必填')
        return false
      }
      if (!this.produceDate) {
        nError('生产日期必填')
        return false
      }
      let obj = {}
      let lotNum = 0
      if (this.lotNo < 10) {
        lotNum = '00' + this.lotNo
      } else if (this.lotNo > 9 && this.lotNo < 100) {
        lotNum = '0' + this.lotNo
      } else {
        lotNum = this.lotNo.toString()
      }
      obj.lotNo = lotNum
      let yy = this.produceDate.getFullYear()
      let mm = (this.produceDate.getMonth() + 1) < 10 ? '0' + (this.produceDate.getMonth() + 1) : (this.produceDate.getMonth() + 1)
      let dd = this.produceDate.getDate() < 10 ? '0' + this.produceDate.getDate() : this.produceDate.getDate()
      obj.produceDate = yy + '-' + mm + '-' + dd
      obj.memo = this.memo
      this.$axios.post(`${httpUrl.url}/manage/lot/add`, obj)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('添加成功')
            this.lotNo = 1
            this.produceDate = ''
            this.memo = ''
            this.getFactorySettingPage()
          }
        })
        .catch(errorHandler('添加失败'))
    },
    cancelAdd () {
      this.lotNo = 1
      this.produceDate = ''
      this.memo = ''
    },
    sercher () {
      this.getFactorySettingPage()
    },
    changePageNo (m) {
      this.reqbody.pageNo = m
      this.getFactorySettingPage()
    },
    changePageSize (n) {
      this.reqbody.pageSize = n
      this.getFactorySettingPage()
    }
  }
}
</script>

<style scoped>
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  .main_right {
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }

  .page_info {
    margin: 15px;
    background-color: #fff;
  }

  .searchBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .table_page {
    text-align: right;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/factory-allocation/production-bath.vue